import { sessionStorageKeyManager } from '@rmstransactions/components';

const receiptUUIDKey = 'driving-record-receipt';
const ConfirmationUUIDManager = sessionStorageKeyManager(receiptUUIDKey);

export default ConfirmationUUIDManager;
